import { post } from '@/utils/axios'

class ProductModel {

    /**
     * 获取产品
     * @param secNavigationId 二级域名id
     * @returns {Promise<*>}
     */
    async getWebsiteProductList(secNavigationId) {
        return post('/v1/product/getWebsiteProductList',{
            secNavigationId
        })
    }

}

export default new ProductModel()
